/**
 * ClientSelectedCard — carte du client sélectionné, partagée OR / Devis / Facture.
 *
 * Même présentation dans les trois saisies : nom, adresse, téléphone cliquable
 * (appel direct depuis un mobile) et e-mail cliquable.
 */
import { User, Mail, Phone, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export const clientLabel = (c) =>
  c ? (c.raison_sociale || `${c.prenom || ""} ${c.nom || ""}`.trim() || c.nom || "") : "";

export default function ClientSelectedCard({ client, onClear, testIdPrefix = "client" }) {
  if (!client) return null;
  const tel = client.tel_principal || client.mobile || client.tel_secondaire || "";
  const email = client.email || "";
  const adresse = [client.adresse, [client.npa, client.localite].filter(Boolean).join(" ")]
    .filter(Boolean)
    .join(", ");

  return (
    <div
      className="mt-2 flex items-start gap-3 p-3 bg-[#f0f9f4] rounded-md border border-[#52a675]/30"
      data-testid={`${testIdPrefix}-selected-card`}
    >
      <User className="w-5 h-5 text-[#52a675] flex-shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-gray-900 break-words" data-testid={`${testIdPrefix}-selected-nom`}>
          {clientLabel(client)}
        </div>
        {adresse && <div className="text-xs text-gray-600 break-words">{adresse}</div>}
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-1.5">
          {tel ? (
            <a
              href={`tel:${String(tel).replace(/\s/g, "")}`}
              className="inline-flex items-center gap-1.5 text-xs font-medium text-[#3d8a5c] hover:underline"
              data-testid={`${testIdPrefix}-selected-tel`}
            >
              <Phone className="w-3.5 h-3.5" /> {tel}
            </a>
          ) : (
            <span className="text-xs text-gray-400 italic">Aucun téléphone</span>
          )}
          {email ? (
            <a
              href={`mailto:${email}`}
              className="inline-flex items-center gap-1.5 text-xs font-medium text-[#3d8a5c] hover:underline break-all"
              data-testid={`${testIdPrefix}-selected-email`}
            >
              <Mail className="w-3.5 h-3.5 flex-shrink-0" /> {email}
            </a>
          ) : (
            <span className="text-xs text-gray-400 italic">Aucun e-mail</span>
          )}
        </div>
      </div>
      {onClear && (
        <Button
          variant="outline"
          size="sm"
          onClick={onClear}
          className="flex-shrink-0"
          data-testid={`${testIdPrefix}-selected-change`}
        >
          <X className="w-3.5 h-3.5 sm:mr-1" />
          <span className="hidden sm:inline">Changer</span>
        </Button>
      )}
    </div>
  );
}
